// extracted by mini-css-extract-plugin
module.exports = {"modal":"index__modal___c8SFw"};